import type { InteractionState } from '../types.js';

export function reduceZoomDomain<T extends InteractionState>(
  domain: T['currentDomain'],
  zoomInEnabled: boolean,
  zoomOutEnabled: boolean,
) {
  return (prev: T): T => ({
    ...prev,
    currentDomain: domain,
    highlightedSeriesId: undefined,
    explore: { pinned: false, visible: false },
    zoom: {
      ...prev.zoom,
      zoomInEnabled,
      zoomOutEnabled,
    },
    select: undefined,
  });
}
